import React, { Component } from 'react';
import Validator from 'validatorjs';
import { InputGroup, FormControl, Form, Image, Col, Row } from 'react-bootstrap';

import { Http } from '../../../../support';
import EmisorPdfPreview from './EmisorPdfPreview';
import Loading from '../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../shared/responses/ResponseError';

class EmisorPdfCustomization extends Component {

  state = {
    data: {},
  }

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
      isValid: false,
    };
  }

  componentDidMount() {
    this.handlePreview();
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  get rules() {
    return {
      'color_representativo': ['regex:/^[a-f0-9]{6,6}$/i'],
      'color_texto': ['regex:/^[a-f0-9]{6,6}$/i']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (event) => {
    const { name, value } = event.target;
    const data = {
      ...this.props.data,
      [name]: value.replace('#', '').trim()
    };

    const result = {
      data,
      isValid: this.validate(data).passes()
    }

    this.props.onFormDataChange(result);
  }

  handlePreview = () => {
    const { emisor } = this.props;

    const params = {
      personalizar: this.props.data || {}
    }

    this.setState({
      rendering: true
    });

    Http.post(`/api/emisores/${emisor.id}/pdf`, params)
      .then(response => {
        this.setState({
          rendering: false,
          preview: response.data.link
        });
      }, (error) => {
        window.ToastManager.show({
          variant: 'danger',
          title: 'Error',
          message: (error.data ? error.data.message : error.message) || 'Error no identificado'
        });

        this.setState({
          rendering: false,
        });
      })
      .catch((error) => {
        window.ToastManager.show({
          variant: 'danger',
          title: 'Error',
          message: (error.data ? error.data.message : error.message) || 'Error no identificado'
        });
      })
  }

  handleOnFileChange = (event) => {
    const { name } = event.target;
    const { emisor } = this.props;

    const files = Array.from(event.target.files);

    this.setState({
      uploading: true,
      uploadError: undefined
    })

    const formData = new FormData()

    files.forEach((file, i) => {
      formData.append(name, file)
    });

    Http.post(`/api/emisores/${emisor.id}/logo`, formData)
      .then(response => {
        window.ToastManager.show({
          variant: 'success',
          title: 'Personalización',
          message: response.message || 'Logo actualizado'
        });

        if (this.props.onLogoUpdated) {
          this.props.onLogoUpdated(response.data);
        }

        const { data } = this.props;

        this.handlePreview(data);
      }, (error) => {
        this.setState({
          uploadError: error.data || error
        })
      })
      .catch((error) => {
        this.setState({
          uploadError: error.data || error
        })
      })
      .finally(() => {
        this.setState({
          uploading: false
        });
      });
  }

  handleOnCloseError = () => {
    this.setState({
      uploadError: undefined
    });
  }

  renderUploadError = () => {
    const { uploadError } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ uploadError }
          onAction={ this.handleOnCloseError }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnCloseError }
        />
      </div>
    );
  }

  render() {
    const { validator, uploading, preview, uploadError } = this.state;
    const { config: baseConfig = {} } = this.props.emisor;
    const { color_representativo = '016F96', color_texto = 'FFFFFF' } = this.props.data;

    const styles = {
      backgroundColor: `#${color_representativo}`,
      color: `#${color_texto}`
    }

    const config = baseConfig || {};

    return (
      <>
       { !!uploadError && this.renderUploadError() }

        <Row>
          <Col xs sm="5">
            <Form.Group>
              <Form.Label>
                <strong>Tu logo</strong>
              </Form.Label>
              <InputGroup className="mb-3">
                <input type='file'
                  name='logo'
                  accept="image/jpg, image/jpeg, image/png"
                  onChange={ this.handleOnFileChange }
                  onClick={ (event)=> {
                      event.target.value = null;
                    }
                  }
                  />
              </InputGroup>
              { uploading && <Loading /> }

              { !!config && !!config.logo && (
                  <Image src={ config.logo } thumbnail />
              )}
            </Form.Group>
          </Col>

          <Col xs sm="4">
            <Form.Group>
              <Form.Label>
                <strong>Color representativo</strong>
              </Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="hexadecimal-addon" style={ styles }>#</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  type="text"
                  name="color_representativo"
                  value={ color_representativo }
                  placeholder="Hexadecimal"
                  aria-label="hexadecimal"
                  aria-describedby="hexadecimal-addon"
                  validator={ validator }
                  onChange={ this.handleOnChange }
                  onBlur={ this.handlePreview }
                />
              </InputGroup>
            </Form.Group>

            <Form.Group>
              <Form.Label>
                <strong>Color Texto</strong>
              </Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="hexadecimal-addon" style={ styles }>#</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  type="text"
                  name="color_texto"
                  value={ color_texto }
                  placeholder="Hexadecimal"
                  aria-label="hexadecimal"
                  aria-describedby="hexadecimal-addon"
                  validator={ validator }
                  onChange={ this.handleOnChange }
                  onBlur={ this.handlePreview }
                />
              </InputGroup>
            </Form.Group>

            <div className="py-2">
            <p className="text-muted">Para que la vista previa de los valores que acabas de configurar se aplique es necesario que quites el foco del campo haciendo click fuera de ellos.</p>
          </div>

            <div className="py-2">
              <strong className="text-muted">Recuerda guardar los cambios para que se apliquen a todas tus facturas.</strong>
            </div>
          </Col>
        </Row>

        { !!preview && (
          <div style={ { width: '100%', height: '600px' } }>
            <EmisorPdfPreview link={ preview } />
          </div>
        )}

      </>
    )
  }
}

export default EmisorPdfCustomization;